import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/i18next"; // Import the i18n configuration
import App from "./App";
import "leaflet/dist/leaflet.css";
import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
